import { render, staticRenderFns } from "./CategoryOverview.vue?vue&type=template&id=7643eaf8&scoped=true&"
import script from "./CategoryOverview.vue?vue&type=script&lang=js&"
export * from "./CategoryOverview.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOverview.vue?vue&type=style&index=0&id=7643eaf8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643eaf8",
  null
  
)

export default component.exports